module.exports = __webpack_public_path__ + "static/img/m_name.142fd96.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/ch/m_name.png
// module id = lXkl
// module chunks = 7